"use client";

import { useEffect } from "react";

export const useDisallowInspect = () => {
  useEffect(() => {
    // Only run in production
    if (process.env.NODE_ENV !== "production") {
      return;
    }

    // Disable F12
    const handleKeyDown = (e: KeyboardEvent) => {
      // F12
      if (e.key === "F12") {
        e.preventDefault();
        return false;
      }

      // Ctrl+Shift+I (Dev Tools)
      if (e.ctrlKey && e.shiftKey && e.key === "I") {
        e.preventDefault();
        return false;
      }

      // Ctrl+Shift+C (Inspect Element)
      if (e.ctrlKey && e.shiftKey && e.key === "C") {
        e.preventDefault();
        return false;
      }

      // Ctrl+Shift+J (Console)
      if (e.ctrlKey && e.shiftKey && e.key === "J") {
        e.preventDefault();
        return false;
      }

      // Ctrl+Shift+K (Chrome DevTools Console)
      if (e.ctrlKey && e.shiftKey && e.key === "K") {
        e.preventDefault();
        return false;
      }

      // Cmd+Option+I (Mac - DevTools)
      if (e.metaKey && e.altKey && e.key === "i") {
        e.preventDefault();
        return false;
      }

      // Cmd+Option+J (Mac - Console)
      if (e.metaKey && e.altKey && e.key === "j") {
        e.preventDefault();
        return false;
      }

      // Cmd+Option+U (Mac - View Source)
      if (e.metaKey && e.altKey && e.key === "u") {
        e.preventDefault();
        return false;
      }

      // Ctrl+Shift+M (Open DevTools responsive design mode)
      if (e.ctrlKey && e.shiftKey && e.key === "M") {
        e.preventDefault();
        return false;
      }

      return null;
    };

    // Disable right-click context menu
    const handleContextMenu = (e: MouseEvent) => {
      e.preventDefault();
      return false;
    };

    // Detect if Dev Tools are open
    const detectDevTools = () => {
      const threshold = 160; // Check if window height/width difference suggests DevTools

      const checkDevTools = () => {
        // Method 1: Check for performance object
        const widthThreshold =
          window.outerWidth - window.innerWidth > threshold;
        const heightThreshold =
          window.outerHeight - window.innerHeight > threshold;

        if (widthThreshold || heightThreshold) {
          handleDevToolsOpen();
        }
      };

      // Check on window resize
      window.addEventListener("resize", checkDevTools);

      // Initial check
      checkDevTools();

      return () => {
        window.removeEventListener("resize", checkDevTools);
      };
    };

    const handleDevToolsOpen = () => {
      // You can log this, redirect, or take other actions
      console.warn("Developer tools detected. Closing...");
      // Optionally: window.location.href = '/';
    };

    // Add event listeners
    document.addEventListener("keydown", handleKeyDown, true);
    document.addEventListener("contextmenu", handleContextMenu, true);

    // Detect DevTools
    const unsubscribeDevToolsDetection = detectDevTools();

    // Disable console methods
    if (process.env.NODE_ENV === "production") {
      const noop = () => {};
      (window.console as any) = {
        log: noop,
        debug: noop,
        info: noop,
        warn: noop,
        error: noop,
        assert: noop,
        clear: noop,
        trace: noop,
        time: noop,
        timeEnd: noop,
        count: noop,
        dir: noop,
        dirxml: noop,
        group: noop,
        groupEnd: noop,
        profile: noop,
        profileEnd: noop,
        table: noop,
      };
    }

    // Try to prevent debugger
    try {
      // This will trigger when debugger is attached
      setInterval(() => {
        const before = new Date();
        debugger;
        const after = new Date();
        // If debugger is attached, this will have a significant delay
        if (after.getTime() - before.getTime() > 100) {
          window.location.href = "/";
        }
      }, 1000);
    } catch (e) {
      // Silently fail
    }

    // Cleanup function
    return () => {
      document.removeEventListener("keydown", handleKeyDown, true);
      document.removeEventListener("contextmenu", handleContextMenu, true);
      if (unsubscribeDevToolsDetection) {
        unsubscribeDevToolsDetection();
      }
    };
  }, []);
};
